module.exports = __webpack_public_path__ + "assets/img/vegetable_active.d3a33beb.png";